import { render, staticRenderFns } from "./ViewDistributorProducts.vue?vue&type=template&id=49c23950&scoped=true&"
import script from "./ViewDistributorProducts.vue?vue&type=script&lang=js&"
export * from "./ViewDistributorProducts.vue?vue&type=script&lang=js&"
import style0 from "./ViewDistributorProducts.vue?vue&type=style&index=0&id=49c23950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c23950",
  null
  
)

export default component.exports